<template>
  <v-form @submit.prevent>
      <tiles-form :tile="doc" />
      <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form"
import router from "@/router";

export default {
  name: "AdminTravelAdd",
  components: {
    TilesForm
  },
  data () {
    return {
      doc: {
        title : "",
        strapline: "",
        flag: "",
        description : "",
        promise: "",
        justification: [],
        pillars: []
      }
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let ref = this.$parent.collection.doc();
      ref.set({
        createdOn: new Date(),
        id: ref.id,
        strapline: this.populateField(this.doc.strapline),
        title: this.populateField(this.doc.title),
        flag: this.populateField(this.doc.flag),
        description: this.populateField(this.doc.description),
        promise: this.populateField(this.doc.promise),
        justification: this.populateField(this.doc.justification),
        pillars: this.populateField(this.doc.pillars)
      }).then(() => {
        router.push({ name: this.$parent.returnRoute })
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    },
    populateField(field) {
      return field ? field : null
    }
  }
};
</script>
